import { createTheme } from "@mui/material/styles";

// Mirrors materialTheme.ts (the v4 theme). Kept in sync manually until the
// v4 theme is retired at the end of the migration (Phase 7).
//
// Component-level defaultProps overrides (e.g. MuiTextField/MuiSelect
// variant: "standard", per MUI_MIGRATION_PLAN.md 5.9) are intentionally
// not set here yet — add them when the batch that actually converts those
// components lands, since there's nothing to validate them against until
// then.
const materialThemeV5 = createTheme({
  direction: "rtl",
  typography: {
    fontFamily: "'Assistant', sans-serif",
  },
  palette: {
    secondary: {
      main: "#ffc107",
    },
  },
});

export { materialThemeV5 };
